import React, { useEffect, useState } from "react";
import { Container, Card, Spinner, Button, ListGroup } from "react-bootstrap";
import axios from "axios";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";

export default function SelectCompanyPage() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadCompanies() {
      try {
        const res = await axios.get(`${API_BASE_URL}/companies`);
        const data = res.data || [];
        setCompanies(data);
      } catch {
        alert("Failed to load companies");
      } finally {
        setLoading(false);
      }
    }
    loadCompanies();
  }, []);

  const handleSelectCompany = (c) => {
    localStorage.setItem("selectedCompany", JSON.stringify(c));
    navigate("/select-branch");
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <Container className="py-4">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title>Select a Company</Card.Title>
          <ListGroup>
            {companies.map((c) => (
              <ListGroup.Item
                key={c.id}
                action
                onClick={() => handleSelectCompany(c)}
              >
                <strong>{c.name}</strong> <br />
                <small>{c.city}, {c.state}</small>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}